$(document).ready(function() {
  $('#checkout-btn').click(function(params) {
    var activeDeliveryMethod = $('.ft-options-active').attr('id');
    // delivery-option-div - local delivery id attr
    // pickup-option-div - pickup delivery id attr
    var cartNoteCount = 0;
    $('.cart-note-validate').each(function() {
      if($(this).val() == ''){
          $(this).addClass('error');
          if($(window).width()<767){  
              $('html, body').animate({
                 scrollTop: $(".cart-note-validate.error").offset().top-100
              }, 1000);
           }
        }else{
          $(this).removeClass('error');
          cartNoteCount++;
        }
    });
    var deliveryDate = $('.neo-input').val();
    if(deliveryZipCode == ''){
      $('#delivery-location-zip').addClass('error');
    }
    $('#delivery-date').remove();
    if(activeDeliveryMethod == 'pickup-option-div'){
      if(deliveryDate == ''){
        $('<p id="delivery-date" class="delivery-location-info" style="color:red">Please select delivery date</p>').insertAfter('.neo-input').fadeOut(5000);
      }
    }else{
       var deliveryZipCode = $('#delivery-location-zip').val();
       if(deliveryZipCode != '' && deliveryDate == ''){
          $('<p id="delivery-date" class="delivery-location-info" style="color:red">Please select delivery date</p>').insertAfter('.neo-input').fadeOut(5000);
        }
    }
    $('#term-and-condition').remove();
    if($('input[name="attributes[I-Agree-To-Terms]"]').is(":checked") == false){
        $('<p id="term-and-condition" class="delivery-location-info" style="color:red">Please accept "I understand that substitutions" checkbox.</p>').insertAfter('.td-non-link').fadeOut(5000);
        if($(window).width()<767){  
            $('html, body').animate({
               scrollTop: $('input[name="attributes[I-Agree-To-Terms]"]').offset().top-300
            }, 1000);
         }
    }
     if(activeDeliveryMethod == 'pickup-option-div'){
       if(cartNoteCount === 3 &&  deliveryDate != '' && $('input[name="attributes[I-Agree-To-Terms]"]').is(":checked") ){
           $("form.cart.cart-form-custom").submit();
        }
     }else{
       if(cartNoteCount === 3 && deliveryZipCode != '' && deliveryDate != '' && $('input[name="attributes[I-Agree-To-Terms]"]').is(":checked") ){
           $("form.cart.cart-form-custom").submit();
        }
     }
    
  });
  // terms and condition checkbox
  $('body').delegate('input[name="attributes[I-Agree-To-Terms]"]', "change", function(){
    checkoutBtn();
  });
  // cart note error on the input and textarea
  $(".cart-note-validate").keypress(function(e){
    if(e.which != 13) {
      $(this).each(function(params) {
        if($(this).val() != ''){
          $(this).removeClass('error');
          checkoutBtn();
        }else{
          $(this).addClass('error');
          checkoutBtn();
        }
      });
    }else{
      e.preventDefault();
      return false;
    }
  });
  // zip code note error on the input and textarea
  $('body').delegate("#delivery-location-zip", "keyup", function(){
     if($(this).val() != ''){
        $(this).removeClass('error');
       checkoutBtn();
      }else{
        $(this).addClass('error');
      }
   });
  //date picker click
   $('body').delegate('.neo-cell-enabled','click',function(){
     const interval = setInterval(function () {
       if($('.neo-input').val() != ''){
         checkoutBtn();
         clearInterval(interval);
       }
     }, 1000);
    
  });

 // $('.ft-options').click(function() {
  $('body').delegate(".ft-options", "click", function(){
     $('#checkout-btn').addClass('btn-inactive');
  });
});
// this function is working for checkout button enable or disabled.
function checkoutBtn(){
  var activeDeliveryMethod = $('.ft-options-active').attr('id');
 var cartNoteValue = 0;
 $('.cart-note-validate').each(function() {
    if($(this).val() != ''){
        cartNoteValue++;
      }
  });
  var deliveryDateInput = $('.neo-input').val();
  var terms = $('input[name="attributes[I-Agree-To-Terms]"]').is(":checked");
  if(activeDeliveryMethod == 'pickup-option-div'){
      if(cartNoteValue === 3 &&  deliveryDateInput != '' && terms === true ){
           $('#checkout-btn').removeClass('btn-inactive');
        }else{
          $('#checkout-btn').addClass('btn-inactive');
        }
  }else{
    var deliveryZip = $('#delivery-location-zip').val();
    if(cartNoteValue === 3 && deliveryZip != '' && deliveryDateInput != '' && terms === true ){
       $('#checkout-btn').removeClass('btn-inactive');
    }else{
      $('#checkout-btn').addClass('btn-inactive');
    }
  }
  
}
checkoutBtn();